import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill';
import { I18nextProvider } from 'react-i18next';
import * as firebase from 'firebase';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import FirebaseProvider from './firebase.provider';
import Admin from './Auth/Admin';
import devConfig from './firebase.config';
import productionConfig from './firebase.config.production';
import i18n from './i18n';
import './index.css';
import Login from './Auth/Login';
import StandList from './Stand/StandList';
import ChooseProducts from './Stand/ChooseProducts';
import Stocktaking from './Stand/Stocktaking';
import AddStocks from './Stand/AddStocks';
import Stand from './Stand/Stand';
import ProductList from './Product/ProductList';
import Product from './Product/Product';
import SaleList from './Sale/SaleList';
import Receipt from './Sale/Receipt';
import Inventory from './Inventory/Inventory';
import Settings from './Navigation/Settings';
import Settlements from './Settlement/SettlementList';
import ShopList from './Admin/ShopList';
import StandTag from './Admin/StandTag';
import Portfolio from './Admin/Portfolio';
import PortfolioProduct from './Admin/Product';
import AdminDashboard from './Admin/Dashboard/Dashboard';
import Auth from './Auth/Auth';
import Layout from './Navigation/Layout';
import Dashboard from './Dashboard/Dashboard';
import Offer from './Offer/Offer';
import OfferList from './Offer/OfferList';

injectTapEventPlugin();

const config = process.env.REACT_APP_SERVER === 'production' ? productionConfig : devConfig;

const fb = firebase
  .initializeApp(config);


ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <MuiThemeProvider>
      <FirebaseProvider firebase={fb}>
        <Router>
          <div>
            <Route exact path="/login" component={Login} />
            <Auth>
              <Route path="/" component={Layout} />
              <div style={{ paddingTop: 64 }}>
                <Route exact path="/dashboard" component={Dashboard} />
                <Route exact path="/settings" component={Settings} />
                <Route exact path="/stands" component={StandList} />
                <Route exact path="/stands/:standKey" component={Stand} />
                <Route path="/stands/:standKey/products" component={ChooseProducts} />
                <Route path="/stands/:standKey/stocktaking" component={Stocktaking} />
                <Route path="/stands/:standKey/addStocks" component={AddStocks} />
                <Route path="/products" component={ProductList} exact />
                <Route path="/products/:productKey" component={Product} />
                <Route path="/sales" component={SaleList} />
                <Route exact path="/sales/:saleKey" component={Receipt} />
                <Route path="/inventory" component={Inventory} exact />
                <Route path="/settlements" component={Settlements} exact />
                <Route path="/offers" component={OfferList} exact />
                <Route path="/offers/:offerKey" component={Offer} exact />
                <Route path="/admin" component={Admin}/>
                <Route exact path="/admin/shops" component={ShopList} />
                <Route exact path="/admin/standtags" component={StandTag} />
                <Route exact path="/admin/portfolio" component={Portfolio} />
                <Route path="/admin/portfolio/:categoryKey/:productKey" component={PortfolioProduct} />
                <Route exact path="/admin/dashboard" component={AdminDashboard} />
              </div>
            </Auth>
          </div>
        </Router>
      </FirebaseProvider>
    </MuiThemeProvider>
  </I18nextProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js